/**
 * Schema of EmailAuditoriaEnvio
 */
import {datetime, Schema} from 'simpli-web-sdk'
import EmailAuditoriaEnvio from '@/model/resource/EmailAuditoriaEnvio'
import * as Helpers from '@/helpers'

export default (model: EmailAuditoriaEnvio): Schema => ({
  idCargaFk: {
    content: model.carga ? model.carga.idCargaPk : 0,
  },

  nroNotaFiscal: {
    textContent: model.carga ? model.carga.nroNotaFiscal : '-',
    content: model.carga ? Helpers.formatScientificNumber(model.carga.nroNotaFiscal) : '-',
  },

  dataCriacao: {
    content: model.carga ? datetime(model.carga.dataCriacao) : '-',
  },

  dataBaixa: {
    content: model.carga ? datetime(model.carga.dataBaixaSistema) : '-',
  },

  nomeGrupo: {
    content: model.nomeGrupo,
  },

  statusAuditoria: {
    content: model.auditoriaMotivo ? model.auditoriaMotivo.nome : '-',
  },

  emailNivel: {
    content: model.emailNivel ? (model.emailNivel.idEmailNivelPk === 0 ? 'Todos' : model.emailNivel.titulo) : '-',
  },

  dataEnvio: {
    content: datetime(model.dataEnvio),
  },
})
